'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _AmazonStaffThanks = require('./AmazonStaffThanks.css');

var _AmazonStaffThanks2 = _interopRequireDefault(_AmazonStaffThanks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonStaffThanks = (_dec = (0, _reactCssModules2.default)(_AmazonStaffThanks2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonStaffThanks, _Component);

  function AmazonStaffThanks(props) {
    (0, _classCallCheck3.default)(this, AmazonStaffThanks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmazonStaffThanks.__proto__ || (0, _getPrototypeOf2.default)(AmazonStaffThanks)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(AmazonStaffThanks, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var pageTitle = 'Thanks for your support';
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'gray-bckgrnd' },
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _container2.default.helmet(pageTitle, _config2.default.app.description, _config2.default.domain + _config2.default.routes.amazon),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'large-page-title' },
              'Thank you for your support!'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'signup-box' },
              _react2.default.createElement(
                'div',
                { styleName: 'signup-box-label' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'next-steps-lbl' },
                  'Next steps'
                ),
                _react2.default.createElement(
                  'h2',
                  null,
                  'Sign up for campaign updates'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We\'ve sent a letter to Amazon management, and we\'ll be meeting with them to ask for a more sustainable retirement plan.'
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(_components.SignupForm, {
                url: _config2.default.amznSignupForm.url,
                id: _config2.default.amznSignupForm.id
              })
            ),
            _react2.default.createElement(_components.AmazonStaffLetters, null),
            _react2.default.createElement(_components.AmazonStaffTakeActionShare, null)
          ),
          _react2.default.createElement(_components.PlanScorecardToActionCenter, null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return AmazonStaffThanks;
}(_react.Component)) || _class);
exports.default = AmazonStaffThanks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AmazonStaffThanks/AmazonStaffThanks.js
// module id = 1458
// module chunks = 0